"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconStories = void 0;
const react_1 = __importDefault(require("react"));
const IconWrapper_types_1 = require("./IconWrapper.types");
const IconStories = (name, Icon) => {
    const storyMeta = {
        title: `Icons/Individual Icons/${name}`,
        component: Icon,
        parameters: {
            importObject: 'Icon',
            importPath: '@carlsberggroup/malty.atoms.icon'
        },
        argTypes: {
            color: {
                description: 'Color options are',
                options: Object.keys(IconWrapper_types_1.IconColor),
                mapping: IconWrapper_types_1.IconColor,
                control: {
                    type: 'radio',
                    label: Object.values(IconWrapper_types_1.IconColor)
                },
                table: {
                    defaultValue: {
                        summary: 'IconColor.DigitalBlack'
                    }
                },
                defaultValue: 'DigitalBlack'
            },
            size: {
                description: 'Size options are',
                options: Object.keys(IconWrapper_types_1.IconSize),
                mapping: IconWrapper_types_1.IconSize,
                control: {
                    type: 'radio',
                    label: Object.values(IconWrapper_types_1.IconSize)
                },
                table: {
                    defaultValue: {
                        summary: 'IconSize.Medium'
                    }
                },
                defaultValue: 'Medium'
            },
            viewBox: {
                table: {
                    disable: true
                }
            },
            onIconClick: {
                table: {
                    disable: true
                }
            }
        }
    };
    const Template = ({ color, size }) => react_1.default.createElement(Icon, { color: color, size: size });
    const story = Template.bind({});
    story.parameters = {
        color: IconWrapper_types_1.IconColor.DigitalBlack,
        size: IconWrapper_types_1.IconSize.Large
    };
    return [storyMeta, story];
};
exports.IconStories = IconStories;
//# sourceMappingURL=IconWrapper.story.js.map